module.exports = __webpack_public_path__ + "img/helicopter_blue.4651177b.png";